import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { OverviewUtilizationCard, ChallengesUtilizationCard } from "../atoms"
import { EkincarePoint, healthChallenges } from "../../../assets/images"
import { handleAppError } from "../../handlers"
import { OverviewApi } from "../../../services"
import { commaingNumber } from "../../../utils"
import { SemiDonughnutGraph } from "../molecules"
import { SpinnerDotted } from "../../common/atoms"

const HealthChallengeCard = ({ contractId, startDate, endDate, totalCustomerCount = 0, classes = '' }) => {
    const [state, setState] = useState({ loading: true })
    const history = useHistory()

    useEffect(() => {
      if(!contractId) return
    
      setState(prevState => { return {...prevState, loading: true} })
      OverviewApi.fetchHealthChallengeOverview({ contract_id: contractId, start_date: startDate, end_date: endDate },
        (res) => {
          setState({...res.data, loading: false})
        },
        (err) => handleAppError(err)
      )
    }, [contractId])

    const { sponsored = false, total_points_earned = 0, completed_challenges = 0, started_challenges = 0, employee_utilized_count = 0, loading } = state

    return (
      <div className={`bg-white border border-gray-200 rounded-lg p-6 ${classes}`}>
        <div className='flex justify-between items-center'>
          <div className='flex items-center gap-3'>
            <img className='h-8 w-8' src={healthChallenges} alt='pre-employment' />
            <div className="flex flex-row gap-4">
              <span className={`text-base font-semibold text-gray-700 leading-none flex gap-4`}>{'Health challenges'}</span>
              { sponsored && <span className='text-white inline-block text-xs rounded-full px-2 py-1 -mt-1 bg-green-1000'>Sponsored</span>}
            </div>
          </div>
          <div className='text-base text-blue-600'>
             <button 
              className='border border-gray-275 rounded-md bg-white px-6 py-2 font-semibold'
              onClick={() => '/challenges' && history.push('/challenges')}
            >
              View insights
            </button>
          </div>
        </div>
          { !loading ?
              <div className='grid grid-cols-3 gap-6 mt-6'>
                <div className='flex flex-col'>
                  <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{'EMPLOYEES WHO TOOK CHALLENGES'}</h3>
                  <SemiDonughnutGraph linerStyles={employee_utilized_count?.toString().length > 5 ? 'w-7/12 text-center bottom-6' : 'bottom-11'} id='preemployment-myChart' total={totalCustomerCount} completed={employee_utilized_count} title='Pre employment utilization' liner={<span><span className='font-semibold text-sm'>{employee_utilized_count}</span> out of {totalCustomerCount} employees</span>} graphClasses='-mt-8 -mb-4' classes='mt-2' metricValue='*includes only active employees' />
                </div>
                <div className='flex flex-col'>
                  <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{'TOTAL CHALLENGES STARTED & COMPLETED'}</h3>
                  <ChallengesUtilizationCard title1={commaingNumber(started_challenges)} title2={commaingNumber(completed_challenges)} liner1='Started' liner2='Completed' classes='flex-1 gap-12 mt-2' />
                </div>
                <div className='flex flex-col'>
                  <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{'TOTAL HEALTH POINTS AWARDED'}</h3>
                  <OverviewUtilizationCard title={<span className="flex flex-row gap-3 text-3xl text-gray-900 mb-0 font-semibold"> <img className="h-8 w-8" src={EkincarePoint} /> {commaingNumber(parseInt(total_points_earned, 10))} </span>} liner={'Total health points awarded to your employees through challenges'} classes='flex-1 mt-2' />
                </div> 
              </div>
              :
              <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
          }
      </div>
    )
  }

export default HealthChallengeCard